<template>
  <section class="form-section">
    <div>
      <template v-if="isEvent" comment="추천이벤트">
        <dl class="form-list__row">
          <dt class="form-list__key" id="eventDiv">이벤트 코드
          </dt>
          <dd>
            <DxValidationGroup ref="validationGroup4">
              <div style="margin-bottom: 6px">
                <div class="agrm-form-input-area">
                  <DxTextBox
                    ref="txtBox5"
                    :placeholder="couponPlaceholder"
                    :disabled="isDisabled"
                    :value="event_value"
                    @value-changed="onEventValueChanged"
                  >
                    <DxValidator>
                      <DxRequiredRule message="이벤트 코드를 입력해주세요" />
                    </DxValidator>
                  </DxTextBox>
                  <button
                  type="button"
                  class="ui-button ui-line-button"
                  v-bind:disabled="isDisabled"
                  @click="couponValid"
                >
                  등록
                </button>
                </div>
              </div>
            </DxValidationGroup>
            <!-- <div class="form-guide-text">
              추전인 전화번호 또는 이벤트 코드를 입력해주세요.
            </div> -->
            <div class="form-guide-text">
              <!-- <p>
                ※ 이벤트 또는 문자(알림)을 통해 안내받은 이벤트 코드를
                입력해주세요.
              </p> -->
              <p>참여하신 쿠폰번호를 입력해 주세요</p>
            </div>
          </dd>
        </dl>
      </template>
      <template v-if="false" comment="탄소중립">
        <div class="form-list__row">
          <p class="form-notice-item" style="font-weight: bold">
            ※ 탄소중립포인트 1,000원 지급 받을 수 있는 대상자로 확인됩니다.
            (가입기한 12월 31일)
          </p>
          <a
            class="form-notice-link"
            style="text-decoration: underline 1px solid black"
            href="https://www.cpoint.or.kr/netzero/site/cntnts/CNTNTS_002.do"
            >☞ 실천활동별 인센티브 제도 확인하러 가기</a
          >
          <p class="form-notice-item">
            친환경활동 참여하시고, 한국환경공단에서 지급하는
            <span style="font-weight: bold"
              >탄소중립포인트 연간 최대 7만원</span
            >
            혜택 받으십시오.
          </p>
          <p class="form-notice-item">
            지구를 위한 자원순환에 동참해주셔서 감사합니다.
          </p>
        </div>
      </template>
      <template v-if="false" comment="갤이득">
        <div>
          <p class="form-guide-text form-notice-item">
            ※ 갤이득 추가보상 관련 계좌입력 진행이 불가한 경우 민팃 이벤트
            페이지를 참고해주세요.
          </p>
          <a
            class="form-guide-text form-notice-link"
            href="/galaxyEvent/document"
          >
            [갤이득 추가보상 추가 서류 제출하기]
          </a>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import DxTextBox from "devextreme-vue/text-box";
import { DxCheckBox } from 'devextreme-vue/check-box'
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule
} from 'devextreme-vue/validator'
import utils from '@/modules/utils'

export default {
  name: "EventInfo",
  components: {
    DxTextBox,
    DxCheckBox,
    DxValidator,
    DxRequiredRule,
    DxValidationGroup
  },
  props: ["isRegDone", "isEvent", "temp_event","ordNum"],
  data: () => ({
    event_value: "",
    eventVal: "",
    isCheckedEvent: false,
    isDisabled:false
  }),
  watch: {
    temp_event(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.event_value = this.temp_event;
        this.$emit('changeEventInfo', newVal)
      }
    },
    event_value(newVal, oldVal) {
      if (newVal !== oldVal) {
        const regex = /\s/g;
        const result = `${newVal}`.replace(regex, "");
        this.event_value = result;
        this.eventVal = result;
      }
    },
    eventVal: {
      deep: true,
      handler(newVal) {
        this.$emit("changeEventInfo", newVal);
      },
    },
  },
  computed: {
	isCouponDisabled(){
	console.log(this.temp_event)
		return this.isRegDone || this.temp_event != ''
	},
    couponPlaceholder() {
      return '쿠폰번호를 입력해 주세요'
    }
  },

  created() {
    this.event_value = this.temp_event;
  },
  mounted () {
    this.validation4()
    this.isDisabled = this.isCouponDisabled
    this.event_value = this.temp_event
  },

  methods: {
    validation4 (e) {
      this.$emit('validation4' , this.$refs['validationGroup4'] , this.$refs['txtBox5'])
    },
    handleFocus(e) {
      const trgtHeight = e.element.offsetHeight + 90;
      window.scrollTo(0, trgtHeight);
    },
    handleSelectBoxClick(isOpened) {
      if (isOpened) {
        document.body.id = "TalkDeposit";
        return;
      }
      if (!isOpened && document.body.id === "TalkDeposit") {
        document.body.id = "";
      }
    },
    onCheckedValueChanged (e) {
      const { value, event } = e
      if (!value) {
        this.event_value = ''
      }
      this.$emit('changeCheckedValue', value)

    },
    onEventValueChanged(e) {
      this.event_value = e.value
    },
    async couponValid(e) {
    	const param = {
	        event_val: this.eventVal,
	        ord_number:this.ordNum
	      }
	      
    	const bankinfoUpdateRes = await this.$http.post('/api/purchase/public/bank/order/coupon-update', param)
        if (bankinfoUpdateRes) {
          const { data: { status, result } } = bankinfoUpdateRes

          if (status === '200') {
            const { error_msg , sgstAmt} = result
            if (error_msg) {
              // 이벤트 코드 초기화
              await this.$nextTick()
              //
                if(error_msg === '이벤트 코드 또는 전화번호가 이벤트 대상이 아닙니다.'){
                  let msg = `
                    <h3>쿠폰을 등록할 수 없어요!</h3>
                    <div style="font-size: 14px; font-weight: 400; line-height:18px; margin-bottom: 10px;">
                      <br>참여 조건 또는 쿠폰번호를<br>다시 확인해 주세요!
                    </div>
                  `

                  this.$Alert.customGrayAlert(msg, true, '다시 등록하기',true)
                  .then(
	                  res => {
	                      return this.event_value = ''
	                  }
                  )                  
                } else {
                  return this.$Alert.alert(error_msg)
                }
              
            } else {
               let msg = `
                    <h3>쿠폰 등록 완료</h3>
                    <div style="font-size: 14px; font-weight: 400; line-height:18px; margin-bottom: 10px;">
                      <br>쿠폰이 정상적으로 등록되었어요 <br>추가 보상금은 별도 입금될 예정이에요
                    </div>
                  `
              this.$Alert.customGrayAlert(msg, true, '확인',false).then(() => {
              	    this.isDisabled = true
              		this.$emit('changeCheckedValue', true)
              		const amtDiv = document.getElementById('amtDiv')
              		this.$emit('changeEventAmt', sgstAmt)
              		const eventDiv = document.getElementById('eventDiv')
					  if (eventDiv) {
					      const trgtHeight = eventDiv.offsetTop
					      window.scrollTo(0, trgtHeight-600)
				      }
	            })
            }
          }
        }
    }

  },
};
</script>
<style>
	.dx-texteditor {
		margin-right : 12px;
	}
</style>


// WEBPACK FOOTER //
// src/views/purchase/sale/components/EventInfo.vue